import { useContext } from "react"
import Select from "../../../components/Select/Select"
import { StaticDataContext } from "../../../views/signup-flow/SignupFormPage/SignupFormPage"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"
import { Option } from "../../../services/ntuc/userService/staticData"

function EducationSelectField(props: FormFieldProps<Option>) {
    const staticData = useContext(StaticDataContext)
    const options = staticData ? staticData.education_level : []

    return (
        <Select
            {...props}
            label="education"
            options={options}
        />
    )
}

export default EducationSelectField
